
import _ from 'lodash'
import { getQuickWords } from "@/api/custom.js"
const QuickWords = {
    state: {
        quickwordList: [],
        inputQuickWord: '',

    },
    mutations: {
        SET_INPUT_QUICK_WORD: (state, payload) => {
            console.log('state,payload', state, payload);
            state.inputQuickWord = payload
        },
        SET_QUICK_WORD_LIST: (state, payload) => {
            state.quickwordList = payload
        }
    },
    actions: {
        // 获取快捷用语
        getQuickWordsList: async ({ commit, state }) => {
            try {
                const res = await getQuickWords()
                const data = res?.data || res?.rows
                console.log("%c Line:27 🧀拿到快捷语数据 data", "color:#e41a6a", data);
                if (Array.isArray(data)) {
                    commit('SET_QUICK_WORD_LIST', data)
                }
                return state.quickwordList
            } catch (error) {
                return state.quickwordList
            }
        }
    }
}

export default QuickWords
